import 'slick-carousel'
import GOOGLEMAP from '../plugins/googlemap'
import GET_ARTICLES from '../plugins/getArticles';

const [w,d,host] = [window,document,location.host]


export default function HOME() {
  // map script
  const km = w.siteinfo.mapApiKeys
  const env_map_key = (!km[host]) ? km['local'] : km[host]
  w.addScript({src:`https://maps.googleapis.com/maps/api/js?v=3&key=${env_map_key}&callback=load.mapScript.resolve`})
  
  // mainvisual
  $(w).on('load', () => d.body.classList.add('is-loaded') )
  $(() => {
    if(w.load['top-mainvisual']==undefined) return false
    w.load['top-mainvisual'].done(() => {
      /*****
       * Slick実行
       */
      $('[data-plugin="slider"]').slick({
        autoplay:true,
        fade: true,
        dots: false,
        speed: 2000,
        autoplaySpeed: 5300,
        pauseOnHover: false,
        pauseOnFocus: false,
        arrows: false
      })
    })
  })

  // news
  $(()=>{
    if(w.load['top-service']==undefined) return false
    w.load['top-service'].done(() => {
      GET_ARTICLES('.p-news-block__list[data-plugin="getArticles"]', {
        makeItem(item){
          return $(`
            <a href="${item.href}" class="p-news-block__item">
              <span class="date">${item.date}</span><span class="cate">［${item.category.name}］</span>
              <p class="subject">${item.title}</p>
            </a>
            <!-- /.p-news-block__item -->
          `)[0]
        }
      })
    })
  })

  // map
  d.addEventListener( 'DOMContentLoaded', () => {
    $.when(
      w.load['mapScript'],
      w.load['contentFooter']
    ).done( () => GOOGLEMAP( { markers:
      [
        {
          title: 'こころね',
          latlng: '34.7403436,137.7411707',
          address: '〒433-8122<br>静岡県浜松市中区上島2-13-62',
          icon: '/asset/img/top/map_peg_kamijima.png',
          iconSize: '100,48',
        },
        {
          title: 'こころね三方原',
          latlng: '34.7752332,137.7296854',
          address: '〒433-8104<br>静岡県浜松市北区東三方町28-3',
          icon: '/asset/img/top/map_peg_mikatabara.png',
          iconSize: '100,48',
        },
        {
          title: 'こころね浜北・あえる浜北',
          latlng: '34.8045346,137.800712',
          address: '〒434-0026<br>静岡県浜松市浜北区東美薗1571-1',
          icon: '/asset/img/top/map_peg_hamakita.png?ts=20201022',
          iconSize: '178,47',
        }
      ]
    } ) )
  } )


}